export const ACCOUNTITZ_TUTORIAL_RESTART_EVENT = 'accountitz:tutorial:restart';

const TUTORIAL_ID = 'invoice-overview';
export const INVOICE_TUTORIAL_VERSION = 1;
const RESTART_SESSION_KEY = `accountitz:tutorial:${TUTORIAL_ID}:restart`;

export const requestTutorialRestart = () => {
   try {
      sessionStorage.setItem(RESTART_SESSION_KEY, 'true');
   } catch {
      // The event below still restarts the tutorial on the current page.
   }

   window.dispatchEvent(new CustomEvent(ACCOUNTITZ_TUTORIAL_RESTART_EVENT));
};

export const consumeTutorialRestartRequest = () => {
   try {
      const shouldRestart = sessionStorage.getItem(RESTART_SESSION_KEY) === 'true';
      sessionStorage.removeItem(RESTART_SESSION_KEY);
      return shouldRestart;
   } catch {
      return false;
   }
};
